import { Flame, Star } from 'lucide-react';
import { useGamification, getLevel, getLevelName, getLevelProgress, getNextLevelThreshold } from '@/hooks/useGamification';
import { cn } from '@/lib/utils';

export function GamificationFooter() {
  const { data: g } = useGamification();

  const points = g?.total_points ?? 0;
  const level = getLevel(points);
  const levelName = getLevelName(level);
  const progress = getLevelProgress(points);
  const nextThreshold = getNextLevelThreshold(points);
  const streak = g?.diary_streak ?? 0;

  return (
    <div className="mx-3 mb-2 rounded-xl border border-sidebar-border/40 bg-sidebar-accent/20 p-3 space-y-2">
      {/* Level + XP */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          <Star className="h-3.5 w-3.5 text-primary shrink-0" />
          <span className="text-[11px] font-semibold text-sidebar-primary-foreground">
            Lv.{level} {levelName}
          </span>
        </div>
        <span className="text-[10px] text-sidebar-foreground/50 font-medium tabular-nums">
          {points.toLocaleString()} XP
        </span>
      </div>

      {/* Progress bar */}
      <div className="h-1.5 w-full rounded-full bg-sidebar-border/40 overflow-hidden">
        <div
          className="h-full rounded-full gradient-primary transition-all duration-700 ease-out"
          style={{ width: `${Math.min(100, progress)}%` }}
        />
      </div>

      {nextThreshold !== Infinity && (
        <p className="text-[9px] text-sidebar-foreground/40 text-right">
          {nextThreshold - points} XP to Lv.{level + 1}
        </p>
      )}

      {/* Diary streak */}
      {streak > 0 && (
        <div className="flex items-center gap-1.5 pt-0.5">
          <Flame className={cn('h-3 w-3 shrink-0', streak >= 7 ? 'text-warning' : 'text-orange-400/70')} />
          <span className="text-[10px] text-sidebar-foreground/60">
            {streak}-day diary streak
          </span>
          {streak >= 7 && (
            <span className="ml-auto text-[9px] text-warning font-semibold">🔥</span>
          )}
        </div>
      )}
    </div>
  );
}
